import React from 'react';
import DashboardScreenEnhanced from '../../src/screens/dashboard/DashboardScreenEnhanced';
import { useAuth } from '../../src/context/AuthContext';

export default function DashboardRoute() {
  const { user } = useAuth();

  // ENHANCED DASHBOARD WITH REACT NATIVE REUSABLES
  return <DashboardScreenEnhanced user={user ?? undefined} />;
}
